import React from 'react';

export const IconSort = () => {
  return (
    <svg width="16" height="19" viewBox="0 0 16 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_80_817)">
        <rect y="2.5" width="16" height="1" fill="#D9D9D9" />
        <rect y="3.5" width="16" height="1" fill="#B3B3B3" />
      </g>
      <g clipPath="url(#clip1_80_817)">
        <rect y="8.5" width="16" height="1" fill="#D9D9D9" />
        <rect y="9.5" width="16" height="1" fill="#B3B3B3" />
      </g>
      <g clipPath="url(#clip2_80_817)">
        <rect y="14.5" width="16" height="1" fill="#D9D9D9" />
        <rect y="15.5" width="16" height="1" fill="#B3B3B3" />
      </g>
      <defs>
        <clipPath id="clip0_80_817">
          <rect y="2.5" width="16" height="2" rx="1" fill="white" />
        </clipPath>
        <clipPath id="clip1_80_817">
          <rect y="8.5" width="16" height="2" rx="1" fill="white" />
        </clipPath>
        <clipPath id="clip2_80_817">
          <rect y="14.5" width="16" height="2" rx="1" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
